export default "__VITE_ASSET__78e4b1bc__"